import { useState, useRef, useEffect, useCallback } from "react";
import { useDispatch } from "react-redux";
import EventEmitter from "../../libs/Events.utils";
import { actionLoginUser } from "../../actions/Auth.action";
import { serviceVerifyOTP } from "../../services/index.services";
// import { actionLoginUser } from "../../../actions/auth_index.action";
// import { serviceRequestOtp, serviceVerifyOTP } from "../../../services/index.services";
// import EventEmitter from "../../../src/libs/Events.utils";
import { useLocation } from 'react-router-dom';
import historyUtils from "../../../src/libs/history.utils";
import SnackbarUtils from "../../libs/SnackbarUtils";



const validate = (values) => {
  const errors = {};
  const otp = values.otp || [];

  if (!otp.length || otp.every((digit) => !digit)) {
    errors.otp = "Please enter the OTP";
  } else if (otp.length !== 8 || otp.some((digit) => !digit || isNaN(digit))) {
    errors.otp = "OTP must be 8 digits";
  }
  return errors;
};


const useOtpVerifyHook = () => {
  const dispatch = useDispatch();
  const [snackbar, setSnackbar] = useState(false);
  const [disableResend, setDisableResend] = useState(false);
  const [timerCounter, setTimerCounter] = useState(30);
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [isValid, setIsValid] = useState(false);
  const [errorOtp, setErrorOtp] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const inputRefs = useRef([]);
  const location = useLocation();
  const contact = location?.state?.data?.contact;
  const contact_key = location?.state?.res?.data?.key;

  let timeout = null;
  let timerInterval = null;

  useEffect(() => {
    inputRefs.current[0]?.focus();
    return () => {
      clearTimeout(timeout);
      clearInterval(timerInterval);
    };
  }, []);

  const _timeoutDisable = () => {
    timeout = setTimeout(() => {
      clearInterval(timerInterval);
      setDisableResend(false);
      setTimerCounter(30);
    }, 30000);

    timerInterval = setInterval(() => {
      setTimerCounter((prevCounter) => prevCounter - 1);
    }, 1000);
  };

  // const handleResendOtp = async () => {
  //   const cont = `${country_code.slice(1)} ${contact}`;
  //   const response = await serviceRequestOtp({ contact: cont });
  //   if (!response.error) {
  //     setDisableResend(true);
  //     _timeoutDisable();
  //   }
  // };




  const handleKeyPress = (e, index) => {

    const value = e.target.value.replace(/\D/g, "").slice(-1);
    const updatedOtp = [...otp];
    updatedOtp[index] = value;
    setOtp(updatedOtp);

    // Move to next input if filled
    if (value && index < inputRefs.current.length - 1) {
      inputRefs.current[index + 1]?.focus();
    }

    if (e.key === "Backspace" && !value && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }

    const filled = updatedOtp.every((digit) => digit !== undefined && digit !== "");
    setIsValid(filled);
  };


  // useEffect(() => {
  //   if (errorOtp) {
  //     const timer = setTimeout(() => setErrorOtp(false), 2000);
  //     return () => clearTimeout(timer);
  //   }
  // }, [errorOtp]);

  const handleChnageContact = useCallback((data) => {
    historyUtils.push('/login');
  }, []);

  const handleSubmit = async () => {
    setSubmitting(true);
    try {
      const errors = validate({ otp });
      if (errors.otp) {
        SnackbarUtils.error(errors.otp || "Please enter the OTP");
        return;
      }
      const cont = `${contact}`.replace(/[+-]/g, "");
      const response = await serviceVerifyOTP({
        contact_key: contact_key,
        otp: otp.join(""),
      });

      if (!response.error) {
        dispatch(actionLoginUser(response.data));
        setErrorOtp(false);
      } else {
        EventEmitter.dispatch(EventEmitter.THROW_ERROR, {
          error: "Invalid Credentials! Please verify.",
          type: "error",
        });
        setErrorOtp(true);
      }
    } catch (error) {
      SnackbarUtils.error("Something went wrong");
    } finally {
      setSubmitting(false);
    }
  };

  return {
    otp,
    inputRefs,
    handleKeyPress,
    isValid,
    // handleResendOtp,
    disableResend,
    timerCounter,
    handleSubmit,
    errorOtp,
    snackbar,
    setSnackbar,
    contact,
    handleChnageContact,
    submitting
  };
};

export default useOtpVerifyHook;
